import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import uuid from 'uuid/v1';

import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableRow,
  TableCell,
  Typography,
  Button,
  colors,
  TableBody
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

// import axios from 'utils/axios';
import { GenericMoreButton } from  '../../../../components';
import CircularProgress from './components/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  inner: {
    minWidth: 700
  },
  details: {
    display: 'flex',
    alignItems: 'center'
  },
  image: {
    marginRight: theme.spacing(2),
    flexShrink: 0,
    height: 56,
    width: 56
  },
  subscriptions: {
    fontWeight: theme.typography.fontWeightMedium
  },
  price: {
    whiteSpace: 'nowrap'
  },
  value: {
    color: colors.green[600],
    fontWeight: theme.typography.fontWeightMedium
  },
  conversion: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  conversionStats: {
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  arrowForwardIcon: {
    marginLeft: theme.spacing(1)
  }
}));

const MostProfitableProducts = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchProducts = () => {
      // axios.get('/api/dashboard/profitable-products').then(response => {
      //   if (mounted) {
      //     setProducts(response.data.products);
      //   }
      // });
      setProducts([
        {
          id: uuid(),
          type: 'freelancer_basic',
          name: 'Freelancer Basic Subscription',
          image: '/images/products/product_freelancer.svg',
          subscriptions: '13,153',
          currency: '$',
          price: '5.00',
          progress: 93
        },
        {
          id: uuid(),
          type: 'freelancer_extra',
          name: 'Freelancer Extra Subscription',
          image: '/images/products/product_freelancer.svg',
          subscriptions: '10,300',
          currency: '$',
          price: '15.00',
          progress: 76
        },
        {
          id: uuid(),
          type: 'agency_basic',
          name: 'Agency Basic Subscription',
          image: '/images/products/product_agency.svg',
          subscriptions: '5,300',
          currency: '$',
          price: '25.00',
          progress: 60
        },
        {
          id: uuid(),
          type: 'enterprise_basic',
          name: 'Enterprise Basic Subscription',
          image: '/images/products/product_enterprise.svg',
          subscriptions: '1,203',
          currency: '$',
          price: '205.00',
          progress: 46
        },
        {
          id: uuid(),
          type: 'enterprise_extra',
          name: 'Enterprise Extra Subscription',
          image: '/images/products/product_enterprise.svg',
          subscriptions: '254',
          currency: '$',
          price: '500.00',
          progress: 41
        }
      ])
    };

    fetchProducts();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={<GenericMoreButton />}
        title="Most Profitable Products"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableBody>
                {products.map(product => (
                  <TableRow
                    hover
                    key={product.id}
                  >
                    <TableCell>
                      <div className={classes.details}>
                        <img
                          alt="Product"
                          className={classes.image}
                          src={product.image}
                        />
                        <div>
                          <Typography variant="h6">{product.name}</Typography>
                          <Typography variant="subtitle2">
                            <span className={classes.subscriptions}>
                              {product.subscriptions}
                            </span>{' '}
                            Active
                          </Typography>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h6">Price</Typography>
                      <Typography
                        className={classes.price}
                        variant="subtitle2"
                      >
                        <span className={classes.value}>
                          {product.currency}
                          {product.price}
                        </span>{' '}
                        monthly
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <div className={classes.conversion}>
                        <div className={classes.conversionStats}>
                          <Typography
                            align="right"
                            variant="h6"
                          >
                            {product.progress}%
                          </Typography>
                          <Typography variant="subtitle2">
                            Conversion Rate
                          </Typography>
                        </div>
                        <CircularProgress value={product.progress} />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <Divider />
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          component={RouterLink}
          size="small"
          to="#"
          variant="text"
        >
          See all
          <ArrowForwardIcon className={classes.arrowForwardIcon} />
        </Button>
      </CardActions>
    </Card>
  );
};

MostProfitableProducts.propTypes = {
  className: PropTypes.string
};

export default MostProfitableProducts;
